import { Component } from '@angular/core';

import { AppUtilityService } from 'src/app/app-utility.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  constructor(private appUtility: AppUtilityService) { }


  ngOnInit(): void {
  // Initialize app theme from localStorage

  this.appUtility.currentThemeSubject.subscribe(theme => {
      if (theme) {
         document.documentElement.setAttribute('data-theme', theme);
      }
    });
  }
}
